export default __webpack_public_path__ + "static/media/creativityFestival2.0dba25ac.png";